import { render } from "./TranslationsTable.vue?vue&type=template&id=5c26c8df"
import script from "./TranslationsTable.vue?vue&type=script&lang=js"
export * from "./TranslationsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__